import React from 'react'
import { translateWithUserLocale } from '../../utils/i18n'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  Icon,
} from '@design/pt-ui'

interface IOutdatedFormatsetsMessageDialogProps {
  open: boolean
  onClose: () => void
  invalidFormatsets: string
  type: 'import' | 'copy'
  onConfirm?: () => void
  goToCopiedProject?: () => void
}

const OutdatedFormatsetsMessageDialog = (
  props: IOutdatedFormatsetsMessageDialogProps,
) => {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle id="alert-dialog-title">Outdated warning</DialogTitle>
      <Typography variant="subtitle1" sx={{ padding: '25px' }}>
        {translateWithUserLocale(
          props.type === 'import'
            ? 'project.import_formatset(s)_outdated'
            : 'project.copy_project_outdated',
        )}{' '}
        {props.invalidFormatsets}
      </Typography>

      <DialogActions>
        <Button onClick={props.onConfirm || props.onClose} color="inherit">
          <Icon
            sx={{
              fontSize: 44,
              color: '#57ac40',
              marginRight: '7px',
            }}>
            check_circle
          </Icon>
          Ok
        </Button>
        {props.type === 'copy' && (
          <Button onClick={props.goToCopiedProject} color="inherit">
            Go to copied project
            <Icon
              sx={{
                fontSize: 48,
                color: '#57ac40',
                marginLeft: '7px',
              }}>
              exit_to_app
            </Icon>
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default OutdatedFormatsetsMessageDialog
